import { useCallback, useState } from "react";

import useRouter from "@vromo/hooks/useRouter";
import Bugsnag from "@vromo/analytics/bugsnag";
import { IntegrationsPageRoute } from "..";

interface IntegrationsPageNave {
    modalOpened?: boolean
}



/** Navigation around integrations page */
export const useIntegrationsNav = ({ modalOpened = false }: IntegrationsPageNave = {}) => {

    const { history } = useRouter()
    const [modalOpen, setModalOpen] = useState(modalOpened)

    /** change current window, while in the integrations page */
    const goToWindow = useCallback((destination: "details" | "list" | "add" | "config", platform?: string): void => {

        const err = () => { throw new Error(`invalid arguments for 'goToWindow' ${destination}`) }
        Bugsnag.leaveBreadcrumb(`Render integration page '${destination}' view`, { platform });

        switch (destination) {
            case "details":
                if (!platform)
                    err()
                history.push(IntegrationsPageRoute.details.replace(":platform", platform!))
                break;

            case "add":
                history.push(IntegrationsPageRoute.add)
                break;

            case "config":
                if (!platform)
                    err()
                history.push(IntegrationsPageRoute.configure.replace(":platform", platform!))
                break;

            case "list":
                history.push(IntegrationsPageRoute.list)
                break;

            default:
                err()
        }
    }, [history])


    /** beautifully close the current modal */
    const closeModal = async () => {
        return new Promise<void>((resolve) => {
            setModalOpen(false)
            setTimeout(() => {
                goToWindow("list")
                resolve()
            }, 200)
        })
    }

    return {
        goToWindow,
        /** beautifully close modal */
        closeModal,
        modalOpen,
        setModalOpen
    }

}